
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Music, ArrowRight } from 'lucide-react';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <header className="relative pt-16 pb-10 px-4 sm:px-6 md:px-8 lg:px-16 max-w-7xl mx-auto">
      <div className="flex flex-col items-center text-center">
        <div className="flex items-center gap-3 mb-4 animate-fade-in">
          <div className="relative h-14 w-14 rounded-xl flex items-center justify-center bg-gradient-to-br from-neon-purple/80 to-neon-blue/80 p-0.5 overflow-hidden">
            <div className="absolute inset-0 bg-black/80 rounded-[3px] m-[1px]"></div>
            <Music className="h-8 w-8 text-white relative z-10" />
            <div className="absolute inset-0 bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink opacity-50 animate-pulse-soft" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gradient-neon">
            Muso360
          </h1>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 max-w-4xl animate-fade-in" style={{ animationDelay: '0.2s' }}>
          The complete platform for independent musicians
        </h2>
        
        <p className="text-lg text-white/80 max-w-3xl mb-6 animate-fade-in" style={{ animationDelay: '0.3s' }}>
          Manage your music career from one place. Release music, track analytics, connect with other musicians, 
          and grow your audience with our all-in-one platform.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 mb-6 animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <Button 
            variant="neon-purple" 
            size="lg" 
            className="group"
            onClick={() => navigate('/auth/signup')}
          >
            Get Started Free
            <ArrowRight className="ml-1 group-hover:translate-x-1 transition-transform duration-200" />
          </Button>
          
          <Button 
            variant="glass" 
            size="lg"
            onClick={() => navigate('/auth/signin')}
          >
            Sign In
          </Button>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
